import React from "react";
import styled from "@emotion/styled";
import { Container } from "@mui/material";
import { Helmet } from "react-helmet";
import DynamicComponentLoader from "../components/DynamicComponent";

export default function Events(props) {
  // useEffect(() => {
  //   console.log(props.data.Hero[0].Image.data[0]);
  // }, [props.data?.Hero[0]]);
  const { Content } = props?.data;

  return (
    <Wrapper disableGutters maxWidth={false}>
      <Helmet>
        <title itemProp="name" lang="en">
          The Kahanoff Centre – Events
        </title>
      </Helmet>
      <DynamicComponentWrapper>
        {Content?.map((block, index) => {
          return <DynamicComponentLoader key={block.Copy} theme={props?.theme} {...block} />;
        })}
      </DynamicComponentWrapper>
    </Wrapper>
  );
}
const Wrapper = styled(Container)`
  .MuiCard-root {
    h3 {
      min-height: 65px;
    }
    p {
      font-size: 12px;
      min-height: 120px;
    }
  }
`;
const DynamicComponentWrapper = styled.div`
  p,
  h3 {
    // max-width: 524px;
  }
`;
